















































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { Carrier } from '@/http';
import { type } from '@/http/interface';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
    },
})
export default class carrierManager extends Vue {
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public stateType = enums.stateType;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public handleClose() {
        this.formData = {
            name: '',
            legalPerson: '',
            contactName: '',
            contactPhone: '',
            reconciliationCycle: '',
            paymentCycle: '',
            generateRainCloth: true,
            adminUserName: '',
            adminPassword: '',
            preAdminPassword: '',
        };
        this.dialogVisible = false;
    }

    public searchValue: any = {
        startTime: '',
        endTime: '',
        name: '',
        contactName: '',
        orderBy: '',
        enabled:'',
        ASC: true,
    };

    public timeList = [];

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('carrierManager', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('carrierManager'))
        ? JSON.parse(localStorage.getItem('carrierManager'))
        : [
              { title: '车队编号', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '法人', isShow: true, disabled: false },
              { title: '联系人', isShow: true, disabled: false },
              { title: '联系人手机号', isShow: true, disabled: false },
              { title: '对账周期（天）', isShow: true, disabled: false },
              { title: '付款周期（天）', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
            //   { title: '是否生成雨布', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];

    public datetimerange(v) {
        if (v) {
            this.searchValue.startTime = v[0];
            this.searchValue.endTime = v[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };

    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('carrierManager_searchValue', JSON.stringify(this.searchValue));
    }
    public resetSearchValue() {
        this.searchValue = {
            startTime: '',
            endTime: '',
            name: '',
            contactName: '',
            orderBy: '',
            enabled:'',
            ASC: true,
        };
        this.timeList = [];
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.loadData();
        sessionStorage.setItem('carrierManager_searchValue', JSON.stringify(this.searchValue));
    }

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 20;
    public isActive: boolean = false;

    public tableData: any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await Carrier.GetList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch {
            this.loading = false;
        }
    }

    public created() {}

    public mounted() {
        this.$refs.draggerImg.imgdrager();
        if (sessionStorage.getItem('carrierManager_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('carrierManager_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            this.searchPagin = sessionStorage.getItem('carrierManager_page')
                ? JSON.parse(sessionStorage.getItem('carrierManager_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('carrierManager_page')
                ? JSON.parse(sessionStorage.getItem('carrierManager_page'))
                : this.searchPagin;

            this.loadData();
        }
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public async toDetail(row) {
        // this.$router.push({
        //     path: '/carrierPortrait',
        //     query: {
        //         id: row.id,
        //     },
        // });
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('carrierManager_page', JSON.stringify(pagin));
        this.loadData();
    }

    public formData: type.AddCarrierVM = {
        name: '',
        legalPerson: '',
        contactName: '',
        contactPhone: '',
        reconciliationCycle: '',
        paymentCycle: '',
        generateRainCloth:true,
        adminUserName: '',
        adminPassword: '',
        preAdminPassword: '',
    };
    public title = '新增车队';
    public addNew() {
        this.title = '新增车队';
        this.formData = {
            name: '',
            legalPerson: '',
            contactName: '',
            contactPhone: '',
            reconciliationCycle: '',
            paymentCycle: '',
            generateRainCloth:true,
            adminUserName: '',
            adminPassword: '',
            preAdminPassword: '',
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.dialogVisible = true;
    }

    public save() {
        if (this.formData.adminPassword !== this.formData.preAdminPassword) {
            this.$message.warning('重复密码输入不一致!');
            return;
        }
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增车队') {
                    await Carrier.Add(this.formData);
                    this.$message.success('新增成功!');
                    this.loadData();
                    this.dialogVisible = false;
                } else {
                    await Carrier.Edit(this.id, this.formData);
                    this.$message.success('编辑成功!');
                    this.loadData();
                    this.dialogVisible = false;
                }
            }
        });
    }

    public id = '';
    public async toEdit(id) {
        this.id = id;
        this.title = '编辑车队';
        let res = await Carrier.GetDetail(id);
        this.formData = {
            name: '',
            legalPerson: '',
            contactName: '',
            contactPhone: '',
            reconciliationCycle: '',
            paymentCycle: '',
            generateRainCloth:true,
            adminUserName: '',
            adminPassword: '',
            preAdminPassword: '',
        };
        this.formData = {
            ...res,
            preAdminPassword: JSON.parse(JSON.stringify(res.adminPassword)),
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.dialogVisible = true;
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public id1: any ='';
    public toDel(id) {
        this.id1 = id;
        this.dialogConfig2 = {
            title: '删除',
            show: true,
        };
        // this.$confirm('确认删除该车队?', '删除车队', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(async () => {
        //         await Carrier.DoDelete(id);
        //         this.$message.success('删除成功');
        //         this.loadData();
        //     })
        //     .catch(() => {});
    }
     confirmOk2() {
        Carrier.DoDelete(this.id1).then((res) => {
            this.$message.success('删除成功');
            this.loadData();
        });
        // Carrier.DoDelete(this.id1)
        // this.$message.success('删除成功');
        // this.loadData();
         this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }

    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.ASC = true;
        } else {
            this.searchValue.ASC = false;
        }
        switch (col.prop) {
            case 'contactName':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'contactPhone':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
            case 'enabled':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
        }
        this.loadData();
    }
}
